import React, { useState } from 'react'
import { postDiscountCoupan } from '../../services/CoupanServices'
import visa from '../../assets/images/png/visa.png'
import americanexpress from '../../assets/images/png/americanexpress.png'
import paypal from '../../assets/images/png/paypal.png'
import applepay from '../../assets/images/png/applepay.png'
import debit from '../../assets/images/png/debit.png'
import phonepay from '../../assets/images/png/phonepay.png'
import Swal from 'sweetalert2'

import { order } from '../../services/BillingService'
import { Navigate, useNavigate } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify'

const CartTotalDetails = ({
  calculateTotalPrice,
  calculateSubTotalPrice,
  cartProduct,
  discountedPrice,
  couponDetails,
  setCouponDetails,
  setDiscountedPrice,
  addressId,
  coupan,
  setCoupan,
  getProductsOfCart,
  products
}) => {
  const [paymentMethod, setPaymentMethod] = useState('cash on delivery')
  const [couponError, setCouponError] = useState('')
  const tokenItem = localStorage.getItem('token')

  const orderDetails = {
    products: products,
    addressId: addressId,
    subTotal: calculateSubTotalPrice().toFixed(2),
    discount: discountedPrice,
    total: calculateTotalPrice().toFixed(2),
    paymentType: paymentMethod,
    tax: 14
  }

  const applyCoupan = async () => {
    const token = localStorage.getItem('token')
    const discountCoupan = {
      code: coupan
    }
    // reset previous error
    setCouponError('')

    if (cartProduct && cartProduct.length !== 0) {
      const res = await postDiscountCoupan(discountCoupan, token)

      console.log('res--->', res)

      if (res?.status === 'fail') {
        setCouponError('Incorrect or Expired coupon') // show validation error
        return // stop further execution
      } else {
      }

      if (res?.data && res?.data?.discount) {
        setCouponDetails(res?.data)
        setDiscountedPrice(res?.data.discount)
      }
    }
  }

  const orderProduct = async () => {
    if (cartProduct && cartProduct.length !== 0) {
      if (addressId === null) {
        toast.error('Select Address!')
      } else {
        const res = await order(orderDetails, tokenItem)
        if (paymentMethod === 'online') {
          window.location.href = res.status
        }
        if (res.status === 'success') {
          Swal.fire({
            position: 'center-center',
            icon: 'success',
            title: 'Your order has been successfully created',
            showConfirmButton: false,
            timer: 1500
          })
          setCoupan('')
          setCouponDetails(null)
          getProductsOfCart()
        }
      }
    }
  }

  return (
    <>
      <div>
        <div>
          <ToastContainer />
          <div className='ps-1 mt-4 mt-lg-5 pt-1'>
            <div className='bg-white p-3 rounded-2 bg-white-border'>
              <p className='mb-0 ff_inter fs_xxsm clr_dark_grey_6'>
                Have a coupon?
              </p>
              <div className='bg-white-border d-flex align-items-center justify-content-between rounded-2 px-1 mt-2'>
                <input
                  className='border-0 coupon-input clr_dark_grey_5 fs_xxsm ff_inter py-2 ps-2'
                  placeholder='Add coupon'
                  value={coupan}
                  onChange={e => setCoupan(e.target.value)}
                  type='text'
                />

                <button
                  onClick={applyCoupan}
                  className='ff_inter fs_2xsm clr_dark_green btn-apply-coupon py-2 bg-white fw-medium'
                >
                  Apply
                </button>
              </div>
              {couponError && <p className='text-danger mt-1'>{couponError}</p>}
            </div>
            <div
              style={{ position: 'sticky', top: 0 }}
              className='bg-white p-3 mt-3 rounded-2 bg-white-border'
            >
              <div className='d-flex align-items-center justify-content-between'>
                <p className='mb-0 ff_inter fs_xxsm clr_dark_grey_6'>
                  Subtotal:
                </p>
                <p className='mb-0 ff_inter fs_xxsm clr_dark_grey_6'>
                  ₹{calculateSubTotalPrice().toFixed(2)}
                </p>
              </div>

              <div
                className={`align-items-center justify-content-between mt-2 ${
                  couponDetails === null ? 'd-none' : 'd-flex'
                }`}
              >
                <p className='mb-0 ff_inter fs_xxsm clr_dark_grey_6'>
                  Discount:
                </p>
                {discountedPrice ? (
                  <div>
                    {couponDetails?.type === 'percent' ? (
                      <p className='mb-0 ff_inter fs_xxsm color_red_2'>
                        <span className='fw-bold'>-</span> {discountedPrice}
                        <span className='fw-bold'>%</span>
                      </p>
                    ) : (
                      <p className='mb-0 ff_inter fs_xxsm color_red_2'>
                        <span className='fw-bold'>-</span>{' '}
                        <span className='fw-bold'>₹</span>
                        {discountedPrice}
                      </p>
                    )}
                  </div>
                ) : (
                  <p className='mb-0 ff_inter fs_xxsm color_red_2'>-</p>
                )}
              </div>
              <div className='d-flex align-items-center justify-content-between mt-2'>
                <p className='mb-0 ff_inter fs_xxsm clr_dark_grey_6'>Tax:</p>
                <p className='mb-0 ff_inter fs_xxsm clr_green'>
                  <span>+</span> <span className='fw-bold'>₹</span>00 .00
                </p>
              </div>
              <div className='hr-line-div mt-3'></div>
              <div className='d-flex align-items-center justify-content-between '>
                <p className='mb-0 ff_inter fw-semibold fs_xxsm mt-3 clr_dark_blue_2'>
                  Total:
                </p>
                <p className='mb-0 ff_inter fw-bold fs_lg mt-3 clr_dark_blue_2'>
                  ₹{calculateTotalPrice().toFixed(2)}
                </p>
              </div>
              <div>
                <div className='mt-3 d-flex align-items-start gap-2'>
                  <div className='radio-btn-margin'>
                    <input
                      className='input-radio mt-1'
                      type='radio'
                      name='paymentMethod'
                      checked={paymentMethod === 'cash on delivery'}
                      onChange={() => setPaymentMethod('cash on delivery')}
                    />
                  </div>
                  <div>
                    <p className='ff_inter fs_xsm clr_dark_blue mb-0'>
                       Cash on delivery
                    </p>
                    <p className='ff_inter fs_3xsm clr_dark_grey_8 mb-0'>
                       Pay with cash upon delivery.
                    </p>
                  </div>
                </div>
                <div className='mt-3 d-flex align-items-start gap-2'>
                  <div>
                    <input
                      className='input-radio mt-1'
                      type='radio'
                      name='paymentMethod'
                      checked={paymentMethod === 'online'}
                      onChange={() => setPaymentMethod('online')}
                    />
                  </div>
                  <div>
                    <p className='ff_inter fs_3xsm clr_dark_blue mb-0'>
                       PhonePe Payment Solutions
                    </p>
                    <img
                      className='w-100 phonepay'
                      src={phonepay}
                      alt='phonepay'
                    />
                  </div>
                </div>
                <div className='mt-3 d-flex align-items-start gap-2'>
                  <input className='input-checkbox' type='checkbox' />
                  <label
                    className='ff_inter fs_6xsm clr_dark_blue'
                    htmlFor='ship'
                  >
                    I would like to receive exclusive emails with discounts and
                    product information
                  </label>
                </div>
              </div>
              <div>
                <button
                  onClick={orderProduct}
                  style={{ height: '40px', paddingBottom: '5px' }}
                  className='common-darkgreen-button text-white ff_inter fs_sm fw-medium w-100 rounded-2 mt-3'
                >
                  Checkout
                </button>
                <div className='d-flex align-items-center justify-content-lg-between justify-content-center gap-1 mt-3'>
                  <img
                    className='payment-images'
                    src={americanexpress}
                    alt='americanexpress'
                  />
                  <img className='payment-images' src={debit} alt='debit' />
                  <img className='payment-images' src={paypal} alt='paypal' />
                  <img className='payment-images' src={visa} alt='visa' />
                  <img
                    className='payment-images'
                    src={applepay}
                    alt='applepay'
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default CartTotalDetails
